import { ConfigProvider, DatePicker, InputNumber } from 'antd';
import dayjs from 'dayjs';
import { debounce } from 'lodash';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setBalancePMFinancial,
  setCollectionPMFinancial,
  setPaymentPMFinancial,
} from '../../contextRedux/ReportPMFinancial/ReportPMFinancialStore';
import ReportPMFinancialService from '../../services/reportPMFinancial/reportPMFinancialService';
import { RootState } from '../../store';
import ChartBalance from './FinancialGantt/ChartBalance';
import ChartCollection from './FinancialGantt/ChartCollection';
import ChartPayment from './FinancialGantt/ChartPayment';

const Report: React.FC = () => {
  const dispatch = useDispatch();

  const reduxFinancial = useSelector((state: RootState) => state.store.reprotPMOfferFinancial);

  const [month, setMonth] = useState<number | null>(moment().month() + 1);
  const [year, setYear] = useState<number | null>(moment().year());
  const [balance, setBalance] = useState<number | null>(null);

  const fetchFinancialData = (month: number | null, year: number | null, bankBalance: number | null) => {
    if (month !== null && year !== null) {
      ReportPMFinancialService.collectionPMFinancial({
        month: month,
        year: year,
      }).then((data) => {
        dispatch(setCollectionPMFinancial(data?.response));
      });
      ReportPMFinancialService.paymentPMFinancial({
        month: month,
        year: year,
      }).then((data) => {
        dispatch(setPaymentPMFinancial(data?.response));
      });
      ReportPMFinancialService.balancePMFinancial({
        month: month,
        year: year,
        bankBalance: bankBalance!,
      }).then((data) => {
        dispatch(setBalancePMFinancial(data?.response));
      });
    }
  };

  const debouncedFetchFinancialData = useCallback(
    debounce((month: number | null, year: number | null, bankBalance: number | null) => {
      fetchFinancialData(month, year, bankBalance);
    }, 500),
    []
  );

  useEffect(() => {
    debouncedFetchFinancialData(month, year, balance);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [month, year, balance]);

  const handleBalanceChange = (value: number | null) => {
    setBalance(value);
  };

  const handleDateChange = (date: dayjs.Dayjs | null) => {
    if (date) {
      setMonth(date.month() + 1); // 0-indexed months
      setYear(date.year());
    } else {
      setMonth(null);
      setYear(null);
    }
  };

  const selectedMonthDate = month !== null && year !== null ? new Date(year, month - 1) : null;

  return (
    <>
      <h1 style={{ marginBottom: 50 }}>Raport Financiar PM</h1>
      <div style={{ width: '30%', marginTop: '16px', marginBottom: '16px' }}>
        <ConfigProvider
          theme={{
            components: {
              DatePicker: {
                cellHoverBg: '#1677ff',
              },
            },
          }}
        >
          <DatePicker
            defaultValue={dayjs()}
            onChange={handleDateChange}
            picker='month'
            style={{ marginBottom: '16px', width: '100%' }}
            allowClear
          />
        </ConfigProvider>
        <InputNumber
          min={0}
          value={balance}
          onChange={handleBalanceChange}
          style={{ marginBottom: '16px', width: '100%' }}
        />
      </div>
      <h2>Incasari</h2>
      {selectedMonthDate && (
        <ChartCollection contracts={reduxFinancial.collectionPMFinancial} selectedMonth={selectedMonthDate} />
      )}
      <h2>Plati</h2>
      {selectedMonthDate && (
        <ChartPayment contracts={reduxFinancial.paymentPMFinancial} selectedMonth={selectedMonthDate} />
      )}
      <h2>Sold</h2>
      {selectedMonthDate && (
        <ChartBalance
          contracts={reduxFinancial.balancePMFinancial}
          selectedMonth={selectedMonthDate}
          bankBalance={balance}
        />
      )}
    </>
  );
};

export default Report;
